const order_members = [
    {
      name: "Елена Шанская",
      country: "Россия",
      year: "2018",
      achievements: "Президент IABC"
    },
    {
      name: "Инна Городнова",
      country: "Россия",
      year: "2018",
      achievements: "Заместитель Президента по общим вопросам"
    },
    {
      name: "Екатерина Мирошниченко",
      country: "Украина",
      year: "2018",
      achievements: "Эксперт в области парикмахерского искусства, основатель салонов красоты"
    },
    {
      name: "Игорь Стоянов",
      country: "Россия",
      year: "2018",
      achievements: "Автор и разработчик уникальных курсов и технологий модного маникюра"
    },
    {
      name: "Наталья Бова",
      country: "Беларусь",
      year: "2018",
      achievements: "Основатель Учебного центра индустрии красоты Bova_School"
    },
    {
      name: "Татьяна Шевчук",
      country: "Казахстан",
      year: "2019",
      achievements: "Судья Международной категории в Nail чемпионатах"
    },
    {
      name: "Ольга Саламатова",
      country: "Россия",
      year: "2019",
      achievements: "Создатель и руководитель учебного центра Нейл Бьюти"
    },
    {
      name: "Светлана Андреева",
      country: "Молдова",
      year: "2019",
      achievements: "Основатель и руководитель проекта «Мастер с Большой Буквы» в BEAUTY сферы"
    },
    {
      name: "Мария Налбантова",
      country: "Таджикистан",
      year: "2019",
      achievements: "Судья Международной категории в Nail чемпионатах"
    },
    {
      name: "Елена Литвинова",
      country: "Туркменистан",
      year: "2019",
      achievements: "Основатель и руководитель обучающего центра Litvinovalab"
    },
    {
      name: "Дарья Дружинина",
      country: "Узбекистан",
      year: "2020",
      achievements: "Директор-Инструктор Академии Danila Art"
    },
    {
      name: "Анна Симоненко",
      country: "Беларусь",
      year: "2020",
      achievements: "Мастер перманентного макияжа, обладательница международных наград"
    },
    {
      name: "Дарья Миронова",
      country: "Казахстан",
      year: "2020",
      achievements: "Визажистка, работающая в театре и кино"
    },
    {
      name: "Элеонора Сергеева",
      country: "Киргизия",
      year: "2020",
      achievements: "Специалист по оформлению бровей, владелица студии микроблейдинга"
    },
    {
      name: "Инга Аванесян",
      country: "Украина",
      year: "2020",
      achievements: "Мастер ногтевого дизайна, обладательница международных наград"
    },
    {
      name: "Вера Иванова",
      country: "Молдова",
      year: "2021",
      achievements: "Мастер ногтевого сервиса, проводящая мастер-классы по дизайну ногтей"
    },
    {
      name: "Гулнара Аманова",
      country: "Таджикистан",
      year: "2021",
      achievements: "Визажистка, обучающая визажистов в своей школе"
    },
    {
      name: "Джамиля Карапетян",
      country: "Туркменистан",
      year: "2021",
      achievements: "Косметолог, специализирующаяся на лазерной эпиляции"
    },
    {
      name: "София Абрамова",
      country: "Россия",
      year: "2021",
      achievements: "Известная косметолог, автор книг о уходе за кожей"
    },
    {
      name: "Ольга Иванова",
      country: "Украина",
      year: "2021",
      achievements: "Стилист-имиджмейкер, проводит тренинги по подбору стиля"
    },
    {
      name: "Дарья Махиня",
      country: "Украина",
      year: "2022",
      achievements: "Выдающийся мастер перманентного макияжа, обладательница международных наград"
    },
    {
      name: "Алина Петрова",
      country: "Беларусь",
      year: "2022",
      achievements: "Мастер по наращиванию ресниц, создательница собственной линии материалов для наращивания"
    },
    {
      name: "Мария Лебедева",
      country: "Киргизия",
      year: "2022",
      achievements: "Профессиональный массажист, специализирующийся на лечебном массаже"
    },
    {
      name: "Людмила Кравченко",
      country: "Узбекистан",
      year: "2022",
      achievements: "Косметолог, основательница линии косметических средств"
    },
    {
      name: "Евгения Сидорова",
      country: "Россия",
      year: "2022",
      achievements: "Владелица сети салонов красоты, предлагающих широкий спектр услуг"
    },
    {
      name: "Дмитрий Вашешников",
      country: "Россия",
      year: "2023",
      achievements: "Учредитель бизнес-школы «Деньги в Индустрии Красоты», Основатель «Галерея Вашешникова»."
    },
    {
      name: "Ирина Лянгус",
      country: "Россия",
      year: "2023",
      achievements: "Руководитель направления Ассоциации Красивый Бизнес. Владелец и основатель школы-студии перманентного макияжа “Irina Lyangus permanent make up school” в Москве"
    },
    {
      name: "Валентина Демичева",
      country: "Россия",
      year: "2023",
      achievements: "ТОП стилист международного класса по оформлению бровей"
    },
    {
      name: "Ксения Чернова",
      country: "Россия",
      year: "2023",
      achievements: "Более 12 лет в бьюти-индустрии – от ремесленника до руководителя студия правильной депиляции “Там где гладко”"
    },
    {
      name: "Наталья Зверева",
      country: "Россия",
      year: "2023",
      achievements: "Руководитель бизнес-школы ДВИК Дмитрия Вашешникова, руководитель салона красоты “Элиза”"
    },
  ];

 export default order_members;
